import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { INPUTTYPES } from '../../../../shared/models/Constants';

@Component({
  selector: 'app-input-validator',
  templateUrl: './input-validator.component.html',
  styleUrls: ['./input-validator.component.scss'],
})
export class InputValidatorComponent implements OnInit, OnChanges {

  @Input() label = ''
  @Input() typeInput: number
  @Input() wrongPassword?: boolean
  @Input() existPhone?: boolean
  @Input() invalidSMSCode?: boolean
  @Input() hasValidationError?: boolean
  @Input() actualPhone?= ''
  @Input() typeInputForm = ''
  @Input() maxLenghtInput = 12
  @Input() configuracion = {
    mensajesError: {
      error_contrasena_formato: 'La contraseña no tiene el formato correcto',
      error_contrasena_incorrecta: 'La contraseña es incorrecta',
      error_telefono_formato: 'El numero de teléfono es incorrecto o tiene una longitud menor a 10 dígitos',
      error_telefono_actual: 'Estas ingresando el mismo numero de teléfono que posees actualmente',
      error_telefono_existente: 'El teléfono ya esta registrado',
      error_sms_longitud: 'El código debe tener una longitud de 6 números',
      error_sms_incorrecto: 'El código de verificación es incorrecto'
    }
  }
  @Output() valueString = new EventEmitter<string>()
  @Output() invalidInputEvent = new EventEmitter<boolean>()
  public textToValidate: string
  public regexPassword = RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,12}$/)
  public regexPhone = RegExp(/^[0-9]{10}$/)
  public regexSMS = RegExp(/^[0-9]{6}$/)
  public iconEye = 'eye'
  public invalidInput: boolean
  public errorMessage = ''
  public hasError = false
  public isWriting = false

  constructor() { }

  ngOnInit() { }

  ngOnChanges(changes: any) {
    // console.log(changes)
  }

  public validateInput() {
    this.hasValidationError = false
    this.hasError = false
    const type = INPUTTYPES[this.typeInput]
    switch (type) {
      case 'password':
        if (this.regexPassword.test(this.textToValidate)) {
          this.invalidInput = false
          this.hasError = false
          this.valueString.emit(this.textToValidate)
        } else {
          this.invalidInput = true
          this.hasError = true
          this.invalidInputEvent.emit(this.invalidInput)
          this.errorMessage = this.configuracion.mensajesError.error_contrasena_formato
        }
        break
      case 'phone_number':
        if (!this.regexPhone.test(this.textToValidate)) {
          this.invalidInput = true
          this.hasError = true
          this.invalidInputEvent.emit(this.invalidInput)
          this.errorMessage = this.configuracion.mensajesError.error_telefono_formato
        } else if (this.actualPhone === this.textToValidate) {
          this.invalidInput = true
          this.hasError = true
          this.invalidInputEvent.emit(this.invalidInput)
          this.errorMessage = this.configuracion.mensajesError.error_telefono_actual
        } else {
          this.invalidInput = false
          this.hasError = false
          this.valueString.emit(this.textToValidate)
        }
        break
      case 'sms':
        if (!this.regexSMS.test(this.textToValidate)) {
          this.invalidInput = true
          this.hasError = true
          this.invalidInputEvent.emit(this.invalidInput)
          this.errorMessage = this.configuracion.mensajesError.error_sms_longitud
        } else {
          this.invalidInput = false
          this.hasError = false
          this.valueString.emit(this.textToValidate)
        }
        break
    }
  }

  public changeIconPassword() {
    const iconInverse = this.iconEye === 'eye' ? 'eye-off' : 'eye'
    const typeInverse = this.typeInputForm === 'password' ? 'text' : 'password'
    this.iconEye = iconInverse
    this.typeInputForm = typeInverse
  }

  public isWritingOnInput() {
    if (this.isWriting === false) {
      this.isWriting = true
    }
  }

}
